export const REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME = 'title'

export const REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH = 255

export const REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS = 2
